import { BCMSDefaultModel, BCMSRecord, Workflow, useGlobalController } from "@bcm-dev/bcms-vite";
import TransferAccountsPage from "components/pages/TransferAccountsPage";
import Classes, { Account } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <TransferAccountsPage /> ];

/**
 * @function TransferAccountsWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "Transfer Accounts" page.
 * 
 * Setting constructor example for state captures:
 * 
 * document.dispatchEvent(new CustomEvent("force-workflow-state", {
  detail: { 
    value: { 
      externalAccounts: [
        { id: "1", nickname: "some nickname 1", type: "some type 1" },
        { id: "0", nickname: "some nickname 0", type: "some type 2" },
      ]
    } 
  } 
}));
 */
export default function TransferAccountsWorkflow(props) {
    const controller = useGlobalController();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Define the constructor function for forcing state through the 'force-workflow-state' event
    const constructor = record => {
      const externalAccountsObj = record.externalAccounts ?? [];
      const externalAccounts = externalAccountsObj.reduce((acc, account) => {
          let accountInstance = Account.initByID(account.id);
          accountInstance = accountInstance === undefined ? 
          BCMSDefaultModel.account()
          : Account.initByID(account.id);

          const mergedObj = { ...accountInstance.record, ...account };
          const mergedAccount = Account.init(mergedObj);
          acc.push(mergedAccount);
          return acc;
      }, []);

      const externalAccountsProp = externalAccounts.length > 0 ? { externalAccounts } : {};

      // Return the new workflow default object.
      return { 
          ...getDefault(controller),
          ...externalAccountsProp
      };
  };

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } constructor={ constructor } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
  BCMSRecord.globalControllerFor(Classes, controller);

    // Initalize external accounts.
    const externalAccounts = Account.initAll().reduce((acc, account) => {
      if(account.isExternal) { acc.push(account); }
      return acc;
    }, []);
    
    // Return the default workflow state
    return { 
        externalAccounts
    };
};